import { render, staticRenderFns } from "./XemCanBo.vue?vue&type=template&id=064474fa&"
import script from "./XemCanBo.vue?vue&type=script&lang=js&"
export * from "./XemCanBo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports